import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Route, Routes, useLocation } from "react-router-dom";
import { HelmetProvider } from 'react-helmet-async';
import Navbar from "./components/Navbar";
import Fleet from "./components/Fleet";
import FleetSUV from "./components/FleetSUV";
import FleetSedan from "./components/FleetSedan";
import FleetSprinter from "./components/FleetSprinter";
import FleetStretch from "./components/FleetStretch";
import Services from "./components/Services";
import Rates from "./components/Rates";
import Home from "./components/Home";
import ContactForm from "./components/ContactForm";
import Testimonials from "./components/Testimonials";
import ReservationForm from "./components/ReservationForm";
import OrlandoTransportation from "./components/OrlandoTransportation";
import Footer from "./components/Footer";

import "./App.css"; // Modern responsive layout styles

const AppContent = () => {
  const location = useLocation();
  const [currentLanguage, setCurrentLanguage] = useState("EN");
  const [screenSize, setScreenSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });

  // Handle responsive screen size changes
  useEffect(() => {
    const handleResize = () => {
      setScreenSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    };

    // Add event listener for window resize
    window.addEventListener('resize', handleResize);
    
    // Set initial viewport meta tag for mobile
    const viewport = document.querySelector('meta[name="viewport"]');
    if (viewport) {
      viewport.setAttribute('content', 'width=device-width, initial-scale=1.0, maximum-scale=5.0, user-scalable=yes');
    }

    // Cleanup event listener
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const handleLanguageChange = (language) => {
    setCurrentLanguage(language);
  };

  const isHomePage = location.pathname === '/';

  const navLinks = {
    EN: {
      home: "Home",
      services: "Services",
      fleet: "Fleet",
      rates: "Rates",
      contact: "Contact Us",
      testimonials: "Testimonials",
      bookNow: "Book Now",
    },
    AR: {
      home: "الرئيسية",
      services: "الخدمات",
      fleet: "الأسطول",
      rates: "الأسعار",
      contact: "تواصل معنا",
      testimonials: "الشهادات",
      bookNow: "احجز الآن",
    },
    ES: {
      home: "Inicio",
      services: "Servicios",
      fleet: "Flota",
      rates: "Tarifas",
      contact: "Contáctenos",
      testimonials: "Testimonios",
      bookNow: "Reservar Ahora",
    },
  };

  return (
    <div className="app-container">
        <header>
          <Navbar
            currentLanguage={currentLanguage}
            navLinks={navLinks}
            onLanguageChange={handleLanguageChange}
            screenSize={screenSize}
          />
        </header>

        <main className={`main-content ${isHomePage ? 'home-content' : ''}`}>
          <div className="content-container">
            <Routes>
              <Route
                path="/"
                element={
                  <Home 
                    currentLanguage={currentLanguage} 
                    screenSize={screenSize}
                  />
                }
              />
              <Route
                path="/fleet"
                element={
                  <Fleet 
                    currentLanguage={currentLanguage}
                    screenSize={screenSize}
                  />
                }
              />
              <Route
                path="/fleet/suv"
                element={
                  <FleetSUV 
                    currentLanguage={currentLanguage}
                    screenSize={screenSize}
                  />
                }
              />
              <Route
                path="/fleet/sedan"
                element={
                  <FleetSedan 
                    currentLanguage={currentLanguage}
                    screenSize={screenSize}
                  />
                }
              />
              <Route
                path="/fleet/sprinter"
                element={
                  <FleetSprinter 
                    currentLanguage={currentLanguage}
                    screenSize={screenSize}
                  />
                }
              />
              <Route
                path="/fleet/stretch"
                element={
                  <FleetStretch 
                    currentLanguage={currentLanguage}
                    screenSize={screenSize}
                  />
                }
              />
              <Route
                path="/services"
                element={
                  <Services 
                    currentLanguage={currentLanguage}
                    screenSize={screenSize}
                  />
                }
              />
              <Route 
                path="/rates" 
                element={
                  <Rates 
                    currentLanguage={currentLanguage}
                    screenSize={screenSize}
                  />
                } 
              />
              <Route 
                path="/contact" 
                element={
                  <ContactForm 
                    currentLanguage={currentLanguage}
                    screenSize={screenSize}
                  />
                } 
              />
              <Route
                path="/testimonials"
                element={
                  <Testimonials 
                    currentLanguage={currentLanguage}
                    screenSize={screenSize}
                  />
                }
              />
              <Route 
                path="/ReservationForm" 
                element={
                  <ReservationForm 
                    currentLanguage={currentLanguage}
                    screenSize={screenSize}
                  />
                } 
              />
              <Route 
                path="/orlando-transportation" 
                element={
                  <OrlandoTransportation 
                    currentLanguage={currentLanguage}
                    screenSize={screenSize}
                  />
                } 
              />
            </Routes>
          </div>
        </main>

        <Footer 
          currentLanguage={currentLanguage}
          screenSize={screenSize}
        />
      </div>
  );
};

const App = () => {
  return (
    <HelmetProvider>
      <Router>
        <AppContent />
      </Router>
    </HelmetProvider>
  );
};

export default App;